export const minimalErgAmount = 300000
export const url = 'https://assembler.ergoutils.org/';
export const txFee = 2000000
export const maxOut = 50